import RoundBizzerdContainer from "../containers/round.bizzerd.container";
import React from "react";
import {translate} from "react-i18nify";
import PersonalEditor from "./editor/personal.editor";
import ButtonEditor from "./editor/button.editor";
import ColorEditor from "./editor/color.editor";
import SecondaryButton from "../buttons/action_secondary/secondary.button";
import ButtonColors from "../buttons/button.colors";
import {connect} from "react-redux";
import {getTemplateById} from "../../../actions/templateActions";
// @ts-ignore
import {checkCompanyNameExists, uploadPassportPhoto} from "../../../actions/personActions";
import 'react-image-crop/dist/ReactCrop.css'
import {TextTypes} from "../../../components/common/FieldTypes"

interface editorProps {
    width: number,
    templateId: string,
    getTemplateById: (templateId) => void,
    uploadPassportPhoto: (file) => void,
    checkCompanyNameExists: (companyname) => void,
    templates: any,
    persons: any,
}

interface editorState {
    template: any,
    selected: number,
    person: any,
    errors: any,
    logoW: number,
    logoH: number,
    newDesign: boolean,
    selectedField?: string,
}


class EditorFlow extends React.Component<editorProps, editorState> {

    constructor(props) {
        super(props);
        let personString = localStorage.getItem("person")
        let person = {};
        if (personString) {
            person = JSON.parse(personString)
        } else {
            person = {}
        }
        let template = {}
        if (this.props.templateId === "newdesign") {
            let templateString = localStorage.getItem("bizzerd")
            if (templateString) {
                template = JSON.parse(templateString)
            }
        }
        this.state = {
            template: template,
            newDesign: this.props.templateId === "newdesign",
            person: person,
            logoW: 0,
            logoH: 0,
            errors: {
                email: "",
                fullname: "",
                companyName: "",

            },
            selected: 1
        }
        if (this.props.templateId !== "newdesign")
            this.props.getTemplateById(this.props.templateId);
        this.changeSelected = this.changeSelected.bind(this)
        this.changePerson = this.changePerson.bind(this)
        this.changeSelectedField = this.changeSelectedField.bind(this)
        this.updateColor = this.updateColor.bind(this)
        this.deleteField = this.deleteField.bind(this)
        this.onChangeIcon = this.onChangeIcon.bind(this)
        this.reset = this.reset.bind(this)
    }

    onChangeIcon(e) {
        // console.log(e.target.id, e.target.value)
        let template = this.state.template
        template.icon = template.icon.map(icon => {
            if (icon._id === e.target.id) {
                icon.type = e.target.value
            }
            return icon
        })
        this.setState({template: template})
    }

    render() {
        let personContent = {
            pasfoto: this.state.person.pasfoto ? this.state.person.pasfoto : "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1680172291/dt3sixmvarf6ht35qpoi.jpg",
            fullname: this.state.person.fullname ? this.state.person.fullname : translate("chooseDesigns.fields.fullname"),
            jobtitle: this.state.person.jobtitle ? this.state.person.jobtitle : translate("chooseDesigns.fields.title"),
            tel: this.state.person.tel ? this.state.person.tel : translate("chooseDesigns.fields.tel"),
            mobile: this.state.person.mobile ? this.state.person.mobile : translate("chooseDesigns.fields.mobile"),
            email: this.state.person.email ? this.state.person.email : translate("chooseDesigns.fields.email"),
            adresveld: this.state.person.adresveld ? this.state.person.adresveld : translate("chooseDesigns.fields.adres"),
            companyname: this.state.person.companyName ? this.state.person.companyName : translate("chooseDesigns.fields.company"),
            website: this.state.person.website ? this.state.person.website : translate("chooseDesigns.fields.website")
        }
        return (
            <div className={"editor-container"}>
                <div className={"editor-right"}>
                    <PersonalEditor person={this.state.person} width={this.props.width}
                                    folded={this.state.selected !== 1} onImageUpload={this.onImageUpload}
                                    changeSelected={this.changeSelected} onChange={this.changePerson}
                                    errors={this.state.errors}/>
                    <ButtonEditor width={this.props.width} folded={this.state.selected !== 2}
                                  icons={this.state.template.icon ? [...this.state.template.icon.map(icon => {
                                      return [icon._id, icon.type]
                                  })] : []}
                                  changeSelected={this.changeSelected} onChange={this.changePerson}
                                  newDesign={this.state.newDesign}
                                  person={this.state.person}
                                  onChangeIcon={this.onChangeIcon}/>
                    {this.state.newDesign ? <></> :
                        <ColorEditor width={this.props.width} folded={this.state.selected !== 3}
                                     selectedField={this.findSelectedField(this.state.selectedField)}
                                     updateColor={this.updateColor} deleteField={this.deleteField} reset={this.reset}
                                     changeSelected={this.changeSelected} onImageUpload={this.onImageUpload}
                        />}
                    <div className={"editor-flow-footer"}>
                        <span>{translate("hd.editor.differentDesign")}</span>
                        <SecondaryButton color={ButtonColors.white} onClick={() => window.location.href = translate("hd.links.enterprise")}
                                         text={translate("hd.editor.designEnterprise")}/>
                        <span>{translate("hd.editor.or")} <a className={"text-link"}
                                                             href={translate("hd.links.businessCards")}>{translate("hd.editor.pickDesign")}</a></span>
                    </div>
                </div>
                <div className={"editor-left"}>
                    <RoundBizzerdContainer drawCircle={false} steps={[350, 250, 200, 200]}
                                           width={this.props.width} onSelectField={this.changeSelectedField}
                                           personContent={personContent}
                                           bizzerdLayout={this.state.template}/>
                </div>

            </div>)
    }

    reset() {
        this.props.getTemplateById(this.props.templateId);
        this.setState({selectedField: undefined})
    }

    deleteField() {
        let template = this.state.template;
        let selectedField = this.findSelectedField(this.state.selectedField)
        if (selectedField)
            template[selectedField.type] = template[selectedField.type].filter(field => {
                return selectedField && field._id !== selectedField.id
            })
        this.setState({template: template, selectedField: undefined})
    }

    updateColor(color) {
        let template = this.state.template;
        let selectedField = this.findSelectedField(this.state.selectedField)
        if (selectedField) {
            template[selectedField.type] = template[selectedField.type].map(field => {
                if (selectedField && field._id === selectedField.id) {
                    if (selectedField.type === "icon")
                        field.backgroundColor = color
                    else
                        field.color = color
                }
                return field
            })
        }
        this.setState({template: template})
    }

    findSelectedField(fieldId) {
        if (!fieldId) {
            return
        }
        let selectedField;
        let color;
        let type;
        this.state.template.text.forEach(textObject => {
            if (textObject._id === fieldId) {
                selectedField = this.translateType(textObject.type)
                color = textObject.color
                type = "text"
            }
        })
        this.state.template.icon.forEach(iconObject => {
            if (iconObject._id === fieldId) {
                selectedField = iconObject.type + " icoon"
                color = iconObject.backgroundColor
                type = "icon"
            }
        })
        selectedField = selectedField.charAt(0).toUpperCase() + selectedField.slice(1);
        return {text: selectedField, color: color, type: type, id: fieldId}
    }

    translateType(type) {
        let returnValue = type
        Object.values(TextTypes).forEach(textType => {
            if (textType.type === type) {
                returnValue = textType.name + " veld"
            }
        })
        return returnValue
    }

    changeSelectedField(fieldId) {

        this.setState({selectedField: fieldId})
    }

    componentWillReceiveProps(nextProps: Readonly<editorProps>, nextContext: any) {
        if (nextProps.templates && nextProps.templates.template) {
            this.setState({template: nextProps.templates.template})
        }
        if (nextProps.persons && nextProps.persons.exists !== undefined) {
            if (nextProps.persons.exists === false) {
                localStorage.setItem("person", JSON.stringify(this.state.person))
                localStorage.setItem("bizzerd", JSON.stringify(this.state.template))
                window.gtag("event", "add_person_info", {template_id: this.props.templateId})
                window.location.href = "/registration"
            } else {
                this.setState({errors: {companyName: translate("hd.errorMessages.companyNameExists")}, selected: 1})
            }
        }

        if (nextProps.persons && nextProps.persons.photoUrl && nextProps.persons.photoUrl.url) {
            if (nextProps.persons.photoUrl.type === "profile")
                this.setState({person: {...this.state.person, pasfoto: nextProps.persons.photoUrl.url}})
            else {
                const all_logos_png = ["http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654972713/pdmpbrpwavvpszf2zpst.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654972713/pdmpbrpwavvpszf2zpst.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654973153/mpm1au0jxgch3jzocpqv.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654973153/mpm1au0jxgch3jzocpqv.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618932/vusysqorbca8qcpdo8lj.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618932/vusysqorbca8qcpdo8lj.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651846978/evjva9lep41wmrpkub2v.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651846978/evjva9lep41wmrpkub2v.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650629254/veipxjed1tgq0emtylmf.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1650629254/veipxjed1tgq0emtylmf.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png", 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651245762/eijjkx7noepn0i7nntq6.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653169896/qqbfc2mktb6pgzcf1o9d.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653169896/qqbfc2mktb6pgzcf1o9d.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618448/qqrsosvqxlxb6icp6weu.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651851849/sk58lbvhkgusxb4pr3qs.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651852499/ld2ichkzv0fmnlqxtiff.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653163205/dcumbpufb7cwuadvezaf.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653164845/kcxflro4cbifpqj2l2qe.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653164845/kcxflro4cbifpqj2l2qe.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653168424/ozibmi9hc3jl3goj6bt2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653168424/ozibmi9hc3jl3goj6bt2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653173165/qmpyv9nlog9nguynf9gv.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653175086/wxqmwhfgyvnod5bh6lvd.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653176009/f7tzfl7acrej0gycydam.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654701629/b9sgvhnfoisetwbubhir.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654700144/pgbyikl6losmr8xa4dzs.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651245762/eijjkx7noepn0i7nntq6.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651852499/ld2ichkzv0fmnlqxtiff.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651851849/sk58lbvhkgusxb4pr3qs.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653173165/qmpyv9nlog9nguynf9gv.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654683262/eveak8bvrqclnvc45utp.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654683262/eveak8bvrqclnvc45utp.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654701629/b9sgvhnfoisetwbubhir.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654891230/h1nesgiirnz2v2qrred8.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654892073/xg752ftsm69gdl28jgo7.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654974174/xvrq9nq2871sg05om6bk.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654892073/xg752ftsm69gdl28jgo7.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618448/qqrsosvqxlxb6icp6weu.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651846978/evjva9lep41wmrpkub2v.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653169896/qqbfc2mktb6pgzcf1o9d.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654699774/gnqujrrenohz6ksdderx.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654700144/pgbyikl6losmr8xa4dzs.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654971769/fdz3lwnyuryhfimscxqy.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651245762/eijjkx7noepn0i7nntq6.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653163205/dcumbpufb7cwuadvezaf.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653176009/f7tzfl7acrej0gycydam.png']
                const all_logos_svg = ['https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541998/afjefnueknwmvze7ujqa.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541998/afjefnueknwmvze7ujqa.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651317700/gyvmrdz1vwg7ufzpvbva.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651843579/ffl4mswrkuonlodk4bfn.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541431/bxrrtqg4iaimcanji3wd.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1652814758/vkdnxqopwi3mfgalvrwf.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1658781888/z27q1sprygdof0aal1bm.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656542236/lofw8wp4ypojthn1cxdg.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656542236/lofw8wp4ypojthn1cxdg.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541440/jtgkn2brh0sqwhm7gfzp.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541431/bxrrtqg4iaimcanji3wd.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650626295/nelkqvhpwmj4pgprutzh.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650626295/nelkqvhpwmj4pgprutzh.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654700006/cs0bxifmqtm5psxyxnmp.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541440/jtgkn2brh0sqwhm7gfzp.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541431/bxrrtqg4iaimcanji3wd.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg']
                if (this.state.template.image) {
                    let images = this.state.template.image
                    images.map(image => {
                        if (image.logo) {
                            image.image = nextProps.persons.photoUrl.url
                            image.objectFit = "contain"
                        }
                        if (all_logos_svg.includes(image.image) || all_logos_png.includes(image.image)) {
                            image.image = nextProps.persons.photoUrl.url
                            image.objectFit = "contain"
                        }
                        return image
                    })
                    this.setState({template: {...this.state.template, image: images}})
                }
            }
        }

    }

    changeSelected(blockNr) {
        let valid = true
        let errors = {}
        if (!this.state.person.email) {
            valid = false;
            errors = {
                ...errors,
                email: "Vul een geldig emailadres in"
            }

        }
        if (!this.state.person.fullname) {
            valid = false;
            errors = {
                ...errors,
                fullname: "Vul je naam in"
            }
        }
        if (!this.state.person.companyName) {
            valid = false;
            errors = {
                ...errors,
                companyName: "Vul je bedrijfsnaam in"
            }

        }

        if (valid) {
            if (blockNr === 4) {
                // console.log("Looking for companyname")
                this.props.checkCompanyNameExists(this.state.person.companyName)
            }
            this.setState({selected: blockNr, errors: errors})

        } else {
            this.setState({errors: errors})
        }
    }

    changePerson(e) {
        if (e.target.id === "fullname") {
            let firstname;
            let lastname;
            if (e.target.value.includes(" ")) {
                let splitted = e.target.value.split(" ")
                firstname = splitted[0];
                if (splitted.length > 1)
                    splitted.splice(0, 1)
                lastname = splitted.join(" ")
            } else {
                firstname = e.target.value;
            }
            this.setState({
                ...this.state, person: {
                    ...this.state.person,
                    firstname: firstname,
                    lastname: lastname ? lastname : "",
                    [e.target.id]: e.target.value
                },
                errors: {
                    ...this.state.errors,
                    [e.target.id]: ""
                }
            })
        } else
            this.setState({
                ...this.state, person: {
                    ...this.state.person,
                    [e.target.id]: e.target.value
                },
                errors: {
                    ...this.state.errors,
                    [e.target.id]: ""
                }
            })
    }


    onImageUpload = (file, type) => {
        const formData = new FormData();
        if (!file)
            return
        if (type === "profile")
            this.setState({person: {...this.state.person, pasfoto: "/ezgif-4-09613decb1.gif"}})
        formData.append("file", file.target.files[0]);
        formData.append("type", type);
        this.props.uploadPassportPhoto(formData);
    };
}

const
    mapStateToProps = (state) => ({
        templates: state.templates,
        persons: state.persons

    });

export default connect(mapStateToProps, {
    getTemplateById,
    uploadPassportPhoto,
    checkCompanyNameExists
})(EditorFlow);